import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BrowserUtils } from '@azure/msal-browser';
import { ProfileComponent } from './core/components/profile/profile/profile.component';
import { PageNotFoundComponent } from './core/components/page-not-found/page-not-found/page-not-found.component';
import { FailedComponent } from './core/components/login/failed/failed.component';
import { UserResolver } from './core/resolvers/user.resolver';
import { DepartmentResolver } from './core/resolvers/department.resolver';
import { adminGuard } from './core/guards/admin-guard';

const routes: Routes = [
  {
    path: 'profile',
    component: ProfileComponent
  },
  {
    path: '',
    redirectTo: 'trade-contracts',
    pathMatch: 'full'
  },
  {
    path: 'login-failed',
    component: FailedComponent
  },
  {
    // TEMPORARY: only exists to support old links in already-sent emails
    // (from before the new panel existed) — looks up the contract's trade
    // and forwards to the panel with that contract pre-expanded. All
    // current in-app navigation goes straight to /trade-panel instead; this
    // route and ContractRedirectComponent can be deleted once old emails
    // referencing /contract/:id are no longer expected to be opened.
    path: 'contract/:id',
    loadComponent: () => import('./features/contract-redirect/contract-redirect.component').then(m => m.ContractRedirectComponent)
  },
  {
    path: 'trade-contracts',
    loadComponent: () => import('./features/trade-contract/trade-contract-list/trade-contract-list.component').then(m => m.TradeContractListComponent),
    resolve: {
      UserResolver
    }
  },
  {
    // TEMPORARY: only exists to support old links in already-sent emails
    // (from before the new panel existed) — redirects straight to its
    // replacement. All current in-app navigation goes straight to
    // /trade-panel instead; this route can be deleted, along with the now
    // fully unreachable TradeOverviewComponent, once old emails referencing
    // /trade-overview/:id are no longer expected to be opened.
    path: 'trade-overview/:id',
    redirectTo: 'trade-panel/:id'
  },
  {
    path: 'trade-panel/:id',
    loadComponent: () => import('./features/trade-contract-panel/trade-contract-panel-page/trade-contract-panel-page.component').then(m => m.TradeContractPanelPageComponent),
    resolve: {
      UserResolver
    }
  },
  {
    path: 'executed-confirmation-notices',
    loadComponent: () => import('./features/confirmation-notice-executed/confirmation-notice-executed-list/confirmation-notice-executed-list.component')
      .then(m => m.ConfirmationNoticeExecutedListComponent),
  },
  {
    path: 'trade-exclusions',
    loadComponent: () => import('./features/trade-exclusion/trade-exclusion-list/trade-exclusion-list.component')
      .then(m => m.TradeExclusionListComponent),
  },
  {
    path: 'users',
    loadComponent: () => import('./features/users/users.component').then(m => m.UsersComponent),
    resolve: {
      DepartmentResolver
    },
    canActivate: [adminGuard]
  },
  {
    path: 'departments',
    loadComponent: () => import('./features/departments/departments.component').then(m => m.DepartmentsComponent),
    canActivate: [adminGuard]
  },
  {
    path: 'statuses',
    loadComponent: () => import('./features/status/status.component').then(m => m.StatusComponent),
    canActivate: [adminGuard]
  },
  {
    path: 'internal-review',
    loadComponent: () => import('./features/internal-review-list/internal-review-list.component').then(m => m.InternalReviewListComponent),
    resolve: {
      UserResolver,
    }
  },
  // ADD ALL NEW PAGES ABOVE THIS 404 PAGE
  {
    path: 'contract/:contractId/email-threads',
    loadComponent: () => import('./features/email-threads/email-threads.component').then(m => m.EmailThreadsComponent)
  },
  {
    path: '**',
    pathMatch: 'full',
    component: PageNotFoundComponent,
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    // Don't perform initial navigation in iframes or popups
    initialNavigation: !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? 'enabledNonBlocking' : 'disabled' // Set to enabledBlocking to use Angular Universal
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
